import styled, { css } from 'styled-components';
import { Color, Screen } from 'styles';

export const StyledGalleryWrapper = styled.section`
  padding: 200px 0;
`;

const MediumGalleryItemStyle = css`
  margin-right: 0;
  width: 100%;
`;

export const StyledGalleryItem = styled.a`
  display: inline-block;
  margin: 25px 25px 0 0;
  position: relative;
  width: calc(25% - 25px);
  max-height: 195px;
  overflow: hidden
  
  &:nth-child(4), &:nth-child(8) {
    margin-right: 0;
  }
  
  img {
    display: block;
    width: 100%;
  }
  
  &:hover {
    > div {
      opacity: 1;
    }
  }
  
  ${Screen.medium(MediumGalleryItemStyle)}
`;

export const StyledGalleryItemOverlay = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  transition: opacity 300ms ease-in-out;
  opacity: 0;
  width: 100%;
  
  svg {
    fill: ${Color.White};
    height: 40px;
    width: 40px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/gallery/gallery.style.js